import {request} from "@/utils/request";

/**
 *
 * 查询历史记录
 */
export function getHistory(data){
    return request({
        url: "/bswjjc/similar/getHistory",
        method: "post",
        data:data
    });
}
/**
 * 删除历史记录
 */
export function delHistory(data){
    return request({
        url: "/bswjjc/similar/delHistory",
        method: "get",
        params:data
    });
}

/**
 * 导出文件
 */
export function getExportFile(data){
    return request({
        url: "/bswjjc/similar/getExportFileUrl",
        method: "get",
        params:data
    });
}

/**
 * 检查是否扣次成功
 */

export function checkDeduction(data){
    return request({
        url: "/bswjjc/similar/checkDeduction",
        method: "get",
        params:data
    });
}


/**
 * 获取检查中间数据
 */
export function getResultHead(data){
    return request({
        url: "/bswjjc/similar/getResultHead",
        method: "get",
        params:data
    });
}


export function addEvalFeedBack(data) {
    return request({
        url: '/bswjjc/evalFeedback',
        method: 'post',
        data
    })
  }